export default __webpack_public_path__ + "static/media/Flag_of_Ghana.324bd432.svg";